import React, {useState, useCallback, useEffect} from "react";

function NewDropdown({thingsList = [], defaultValue, onSelectThing, additionalClassName}) {
  const [dropdownClick, setDropdownClick] = useState(false);
  const [selectedStats, setSelectedStats] = useState(defaultValue ? defaultValue : thingsList[0]);
  const handleChangeItem = useCallback((thing, dropdownClick) => {
    setSelectedStats(thing);
    setDropdownClick(!dropdownClick);
    onSelectThing(thing);
  }, []);

  useEffect(() => {
    if (defaultValue) {
      setSelectedStats(defaultValue);
    }
  },[defaultValue]);

  return (
    <div className={`dropdown ${additionalClassName}`}>
      <button className="dropdown-btn" onClick={() => setDropdownClick(!dropdownClick)}>
        {selectedStats.name}
        <i className="mdi mdi-chevron-down"/>
      </button>
      {
        dropdownClick &&
        <ul>
          {
            thingsList.map((thing, index) => {
              return (
                <li key={`dropdown-${thing.enumKey}-${index}`}
                    onClick={() => handleChangeItem(thing, dropdownClick)}>{thing.name}</li>
              )
            })
          }
        </ul>
      }
    </div>
  );
}

export default NewDropdown;
